import React, { useState, useEffect } from "react";
import { MdDelete } from "react-icons/md";
import { IoExpand } from "react-icons/io5";
import { FaEdit, FaSearch } from "react-icons/fa";
import axios from "axios";
import AddTeamLead from "./addTeamLead";
import EditTeamLeadForm from "./editTeamlead";
import ViewTeamLeadDetails from "./viewTeamlead";
import DeleteConfirmationPopup from "../deleteConfirmation";
const UserTable = ({ nav }) => {
  const teamsURL = process.env.REACT_APP_API_Team;
  const apiUrl = process.env.REACT_APP_API_Teamleads;
  const [showForm, setShowForm] = useState(false);
  const [showEditForm, setEditForm] = useState(false);
  const [showDetails, setShowDetails] = useState(false);
  const [teamLeads, setTeamLeads] = useState([]);
  const [loading, setLoading] = useState(false);
  const [selectedUserId, setSelectedUserId] = useState(null);
  const [showDeleteConfirmation, setShowDeleteConfirmation] = useState(false);
  const [deleteUserId, setDeleteUserId] = useState(null);
  const [serialNumber, setSerialNumber] = useState(1);
  const [searchQuery, setSearchQuery] = useState("");
  const [teams, setTeams] = useState([]);
  const handleDeleteClick = async (userId) => {
    setShowDeleteConfirmation(true);
    setDeleteUserId(userId);
  };
  const getTeamNameById = (teamLeadId) => {
    const team = teams.find((team) => team.id === teamLeadId);
    return team ? team.name : "Unknown Team";
  };
  const filteredTeamLeads = teamLeads.filter((teamLead) => {
    const fullName = teamLead.first_name + " " + teamLead.last_name;
    return (
      fullName.toLowerCase().includes(searchQuery.toLowerCase()) ||
      teamLead.email.toLowerCase().includes(searchQuery.toLowerCase()) ||
      teamLead.contact_number.includes(searchQuery) ||
      getTeamNameById(teamLead.team_lead_id)
        .toLowerCase()
        .includes(searchQuery.toLowerCase())
    );
  });

  const handleSearchChange = (e) => {
    setSearchQuery(e.target.value);
  };
  const fetchTeams = async () => {
    setLoading(true);
    try {
      const response = await axios.get(teamsURL);
      setTeams(response.data.body);
    } catch (error) {
      console.error("Error fetching teams:", error);
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    fetchTeams();
  }, []);

  const handleConfirmDelete = async () => {
    try {
      await axios.delete(`${apiUrl}/${deleteUserId}`);
      setTeamLeads((prevUsers) =>
        prevUsers.filter((user) => user.id !== deleteUserId)
      );
      setShowDeleteConfirmation(false);
    } catch (error) {
      console.error("Error deleting user:", error);
    }
  };

  const handleCancelDelete = () => {
    setShowDeleteConfirmation(false);
  };

  const fetchTeamLeads = async () => {
    setLoading(true);
    try {
      const response = await fetch(apiUrl);
      if (!response.ok) {
        throw new Error("Failed to fetch teams");
      }
      const data = await response.json();
      setTeamLeads(data.body);
    } catch (error) {
      console.error("Error fetching testers:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchTeamLeads();
  }, [showForm, setShowForm, showEditForm, setEditForm]);

  const handleAddClick = () => {
    setShowForm(true);
  };

  const handleEditClick = (userId) => {
    setEditForm(true);
    setSelectedUserId(userId);
  };

  const handleViewClick = (userId) => {
    setShowDetails(true);
    setSelectedUserId(userId);
  };

  return (
    <div className="bg-gray-200 min-h-screen">
      <div className="container mx-auto">
        {showForm ? (
          <AddTeamLead setShowForm={setShowForm} />
        ) : showEditForm ? (
          <EditTeamLeadForm id={selectedUserId} setEditForm={setEditForm} />
        ) : showDetails ? (
          <ViewTeamLeadDetails
            teamId={selectedUserId}
            setShowDetails={setShowDetails}
          />
        ) : (
          <>
            <div className="flex flex-col md:flex-row justify-between items-center pt-10 mb-4 pl-10 pr-10">
              <h2 className="text-2xl font-bold">All TeamLeads</h2>
              <div className="flex items-center mt-4 md:mt-0">
                <div className="form-control relative ml-4">
                  <FaSearch className="absolute top-1/2 left-3 transform -translate-y-1/2 text-gray-400" />
                  <input
                    type="text"
                    placeholder="Search"
                    className="pl-10 input input-bordered w-30 md:w-auto"
                    value={searchQuery}
                    onChange={handleSearchChange}
                  />
                </div>
                <button
                  onClick={handleAddClick}
                  className="btn btn-xs sm:btn-sm md:btn-md lg:btn-md bg-primaryColor text-[white] ml-8"
                >
                  Add TeamLead
                </button>
              </div>
            </div>
            <div className="overflow-x-auto ml-10 mr-10 pl-10 pr-10 pb-10 bg-[#FFFFFF]">
              <table className="table-auto w-full">
                <thead>
                  <tr>
                    <th className="px-4 py-2 text-left">Serial No.</th>
                    <th className="px-4 py-2 text-left">Name</th>
                    <th className="px-4 py-2 text-left">Team Name</th>
                    <th className="px-4 py-2 text-left">Email</th>
                    <th className="px-4 py-2 text-left">Contact Number</th>
                    <th className="px-4 py-2">Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {loading ? (
                    <tr>
                      <td colSpan="8" className="text-center py-4">
                        Loading...
                      </td>
                    </tr>
                  ) : filteredTeamLeads.length === 0 ? (
                    <tr>
                      <td colSpan="8" className="text-center py-4">
                        No team leads found
                      </td>
                    </tr>
                  ) : (
                    filteredTeamLeads.map((teamLead, index) => (
                      <tr key={teamLeads.id}>
                        <td className="border-t border-b  border-[#ADA7A7] px-4 py-2 text-left">
                          {serialNumber + index}
                        </td>
                        <td className="border-t border-b  border-[#ADA7A7] px-4 py-2 text-left">
                          {teamLead.first_name + " " + teamLead.last_name}
                        </td>
                        <td className="border-t border-b  border-[#ADA7A7] px-4 py-2 text-left">
                          {teamLead.team_name}
                        </td>
                        <td className="border-t border-b  border-[#ADA7A7] px-4 py-2 text-left">
                          {teamLead.email}
                        </td>
                        <td className="border-t border-b  border-[#ADA7A7] px-4 py-2 text-left">
                          {teamLead.contact_number}
                        </td>
                        <td className="border-t border-b border-[#ADA7A7] px-4 py-2">
                          <div className="flex justify-center items-center space-x-2">
                            <button
                              onClick={() => handleViewClick(teamLead.id)}
                              className="text-blue-500 hover:text-blue-700"
                            >
                              <IoExpand color="green" />
                            </button>
                            <button
                              onClick={() => handleEditClick(teamLead.id)}
                              className="text-green-500 hover:text-green-700"
                            >
                              <FaEdit color="blue" />
                            </button>
                            <button
                              onClick={() => handleDeleteClick(teamLead.id)}
                              className="text-red-500 hover:text-red-700"
                            >
                              <MdDelete color="red" />
                            </button>
                          </div>
                        </td>
                      </tr>
                    ))
                  )}
                </tbody>
              </table>
            </div>
          </>
        )}
        {showDeleteConfirmation && (
          <DeleteConfirmationPopup
            onCancel={handleCancelDelete}
            onConfirm={handleConfirmDelete}
          />
        )}
      </div>
    </div>
  );
};

export default UserTable;
